import {MessageBase} from './message-base';
import {DataSeries} from '../DoraData/data-series';
import {PositionElement} from '../Utility/position-element';

export class MessageSeriesSelected  extends MessageBase<MessageSeriesSelected> {
  private datasSeries: DataSeries[] = [];
  private callerPosition: PositionElement = null;
  constructor(dataSeries: DataSeries[], callerPosition: PositionElement = null) {
    super(MessageSeriesSelected);
    this.datasSeries = dataSeries;
    this.callerPosition = callerPosition;
  }

  get DatasSeries(): DataSeries[] {
    return this.datasSeries;
  }

  get CallerPosition(): PositionElement {
    return this.callerPosition;
  }
}
